import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { localizationService } from './services/localization.js';

import { AboutUs } from './pages/AboutUs.js';
import { HomePage } from './pages/Homepage.js';
import { ProductsPage } from './pages/ProductsPage.js';
import { ContactUs } from './components/ContactUs/ContactUs.js';
import { NewItems } from './components/NewItems/NewItems.js';

const App = () => {

  const [currentLang, setCurrentLang] = useState('EN');

  useEffect(() => {
    localizationService.currentLang$.subscribe(lang => {
      setCurrentLang(lang);
      if (lang === 'AR') {
        document.body.dir = 'rtl';
      } else {
        document.body.dir = 'ltr';
      }
    });
  });

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />}/>
        <Route exact path="/product" element={<ProductsPage />}/>
        <Route exact path="/new-items" element={<NewItems />}/>
        <Route exact path="/contact-us" element={<ContactUs />}/>
        <Route exact path="/about" element={<AboutUs />}/>
      </Routes>
    </Router>
  );
}

export default App;
